// Models
import { Sequence } from '../../features/session/sessionModels';

/**
 * @function getRemainingNumbers
 * Calculates how many numbers are remaining for a single pattern
 *
 * @param {array} called Numbers called up to this point
 * @param {array} sequence The sequence of numbers
 * @param {array} numbers Numbers in card
 * @param {array} wildcards Wildcard numbers in card
 * @param {array} daubed Daubed numbers
 * @returns
 */
function getRemainingNumbers(
    called: number[],
    sequence: Sequence,
    numbers: number[],
    wildcards: number[],
    daubed: number[] | false = false,
) {
    const variantNumbers: number[] = called.filter((number) => {
        if (daubed !== false) {
            return (
                sequence.pattern.includes(numbers.indexOf(number) + 1) &&
                daubed.includes(number)
            );
        } else {
            return sequence.pattern.includes(numbers.indexOf(number) + 1);
        }
    });
    const wildcardNumbers: number[] = wildcards
        .filter((wildcardIndex) => {
            return (
                sequence.pattern.includes(wildcardIndex + 1) &&
                !variantNumbers.includes(numbers[wildcardIndex])
            );
        })
        .map((item) => numbers[item]);

    return [...variantNumbers, ...wildcardNumbers];
}

// Exports
export default getRemainingNumbers;
